import { SellerReqOtpToLoginForm } from "../../components/seller/SellerReqOtpToLoginForm";

import React from "react";
import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';


function SellerReqOtpToLogin() {

  return (
    <div className="tw-px-5 tw-w-96 tw-inline-block tw-justify-center">

      {/* <div className="tw-mt-10 tw-flex tw-items-center tw-justify-center">
        <img className="" src="/medib_logo.png" width="50" />
        <span className="tw-text-4xl tw-ml-2">Seller Bids</span>
      </div> */}

      <div className="tw-mt-20">
        <span className="tw-text-3xl">Seller Login</span>
      </div>

      <div className="tw-mt-10">
        <SellerReqOtpToLoginForm />
      </div>

      <div className="tw-mt-5">
        <span>Click <Link href="/seller/register">here</Link> to Register.</span>
      </div>

      <div className="tw-fixed tw-bottom-5 tw-opacity-25 tw-text-xs tw-italic">
        <span>Click <Link href="/emp/login">here</Link> to Employee login.</span>
      </div>

    </div>
  );

}


export { SellerReqOtpToLogin };
